// extracted by mini-css-extract-plugin
export default {"progressBar":"styles_progressBar__OqyoQ","insideProgressBar":"styles_insideProgressBar__dAk4C"};